var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudUpload2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M13.333 54.14c-4.02-2.69-6.666-7.273-6.666-12.473 0-7.812 5.971-14.23 13.599-14.936C21.826 17.241 30.068 10 40 10s18.174 7.24 19.734 16.731c7.628.707 13.6 7.124 13.6 14.936 0 5.2-2.647 9.783-6.667 12.474m-40-.808L40 40m0 0 13.333 13.333M40 40v30"
})));
export default SvgCloudUpload2;